import { PrimaryButton } from "@fluentui/react";
import { useRef, useEffect } from "react";
import { primaryButtonStyles } from "../../common/views/DefaultStyles";
import { CartItemInfo, EditCartItemModel } from "../models/CartModel";
import useCartVM from "../viewmodels/CartVM";
import CartItemView from "./CartItemView";

export type addCartFunc = (productId: number, qty: number) => void;

export type AddCartProps = {
    addToCart: addCartFunc;
}

export type CartProps = {
    id: number;
}

export default function CartView({ id }: CartProps) {
    const hasLoaded = useRef(false);

    const vm = useCartVM(id);

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.onLoad();
    }, [vm]);

    const onEdit = (item: CartItemInfo, newQty: number) => {
        const model: EditCartItemModel = {
            id: item.id,
            qty: newQty
        };

        vm.edit(model);
    }

    const onDelete = (item: CartItemInfo) => {
        const msg = "Are you sure to remove the product from cart?";

        if (window.confirm(msg)) {
            vm.del(item.id);
        }
    }

    const onCheckout = () => {
        window.open("/checkout/" + id, "_self");
    }

    const checkoutButton = () => {
        return <>
            <PrimaryButton
                onClick={onCheckout}
                style={{ width: "100%" }}
                styles={primaryButtonStyles}
            >Checkout $ {vm.getTotal().toFixed(2)}</PrimaryButton>
        </>;
    }

    return <div className="ph-10" style={{ maxWidth: 800 }}>
        <div className="font-title left pb-15">Carts</div>

        {vm.cart !== undefined && vm.cart.items.map((item: CartItemInfo, index?: number) => {
            return <div key={item.id}>
                <CartItemView
                    item={item}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    qtyOptions={vm.qtyOptions}
                />

                <div className="pv-20">
                    <hr color="lightGray" style={{ height: 1, border: "none" }} />
                </div>
            </div>
        })}

        {vm.cart !== undefined && vm.cart.items.length > 0 && <div className="pb-20">
            {checkoutButton()}
        </div>}
    </div>
}